var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.166.925c1.002 0 1.827.753 1.903 1.708l.006.145v12.444c0 .974-.777 1.773-1.76 1.847l-.149.006H2.833c-1.002 0-1.826-.753-1.902-1.708l-.006-.145V2.778c0-.974.777-1.773 1.76-1.847l.148-.006h18.333zM9.968 9.628l-.725.61-.82.706-.905.795-.583.518a306.96 306.96 0 00-3.427 3.103l-.728.67.053.006h18.35l.036-.006-1.587-1.458-.844-.768-1.231-1.11-1.17-1.04-.736-.646-.692-.598-.878-.742-.753.661c-.39.342-.85.524-1.328.524-.478 0-.938-.182-1.329-.524-.224-.196-.503-.441-.703-.701zm-7.95-7.152l-.122.035-.03.097a.59.59 0 00-.025.17v12.444l.002.048a.862.862 0 00.039.167l.01.037.124.034.42-.388 1.679-1.538 1.63-1.473 1.533-1.361.714-.623.67-.576.622-.524.002-.114-7.269-6.435zm19.974.191l-7.114 6.298.577.487.719.619 1.167 1.023.825.734 1.288 1.16 1.77 1.615.771.712.011-.058.002-.035V2.778A.39.39 0 0022 2.694l-.007-.027zM2.8 1.965l8.445 7.47.138.12c.183.16.391.259.617.259.226 0 .434-.1.616-.258l5.512-4.867L21.2 1.966 2.8 1.965z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon_send.c1d5efb89508bef65ae6f13dd0762c67.svg";
export { ForwardRef as ReactComponent };